import {
  useMutation,
  type UseMutationOptions,
} from '@tanstack/react-query';

import type {
  CreateStandalonePatientVisitRequest,
  CreateStandalonePatientVisitResponse,
} from '../../types/api';
import { useVideaNotesApi } from '../context';

export const useCreateStandalonePatientVisit = (
  options?: Omit<
    UseMutationOptions<
      CreateStandalonePatientVisitResponse,
      Error,
      CreateStandalonePatientVisitRequest
    >,
    'mutationFn'
  >,
) => {
  const { createStandalonePatientVisit } = useVideaNotesApi();

  return useMutation<
    CreateStandalonePatientVisitResponse,
    Error,
    CreateStandalonePatientVisitRequest
  >({
    ...options,
    mutationFn: async (data) => {
      const response = await createStandalonePatientVisit(data);

      if (!response) {
        throw new Error('Failed to create standalone patient visit');
      }

      return response;
    },
  });
};
